<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Exclusión
        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-sm>
                <v-row dense>
                    <v-col cols="12" sm="12">
                        <v-stepper v-model="ii" vertical class="removeBorder">
                            <!-- Certificados -->
                            <v-stepper-step :complete="ii > 1" step="1"> Escoger Seguro </v-stepper-step>

                            <v-stepper-content step="1">
                                <v-row dense align="center" justify="center">
                                    <v-col cols="12" sm="4" v-for="(v,k) in listGeneral.listDetalle" :key="k">
                                        <v-tooltip bottom color="primary">
                                            <template v-slot:activator="{ on }">
                                                <v-img :src="v.foto" contain height="300px" max-height="300px" v-on="on"></v-img>
                                            </template>
                                            <span>
                                                <table width="100%">
                                                    <tbody>
                                                        <tr>
                                                            <td> <strong class="white--text body-2">Marca: </strong> </td>
                                                            <td class="body-2" v-html="v.marca"> </td>
                                                        </tr>
                                                        <tr>
                                                            <td> <strong class="white--text body-2">Modelo: </strong> </td>
                                                            <td class="body-2" v-html="v.modelo"> </td>
                                                        </tr>
                                                        <tr>
                                                            <td> <strong class="white--text body-2">Año: </strong> </td>
                                                            <td class="body-2" v-html="v.anio"> </td>
                                                        </tr>
                                                        <tr>
                                                            <td> <strong class="white--text body-2">Cédula: </strong> </td>
                                                            <td class="body-2" v-html="v.numeroDocumento"> </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </span>
                                        </v-tooltip>
                                        <div class="text-center">
                                            <h3 class="headline">Placa: {{ v.placa }}</h3>
                                        </div>
                                        <v-btn block rounded dark color="primary" @click="exclusion(v)">Realizar Exclusión</v-btn>
                                    </v-col>
                                </v-row>
                            </v-stepper-content>

                            <!-- Quitar Accesorios -->
                            <v-stepper-step :complete="ii > 2" step="2"> Excluir Objeto</v-stepper-step>
                            <v-stepper-content step="2">
                                <StepperExclusionAccesorioComponent :load="ii == 2 ? true : false"
                                    :parametros="parametros" :obSearch="obSearch"
                                    :listMotivoExclusion="listGeneral.listMotivoExclusion" />

                                <v-row dense>
                                    <v-col class="text-right">
                                        <v-btn outlined rounded color="danger" class="mr-1" @click="--ii">Anterior</v-btn>
                                        <v-btn rounded dark color="primary" @click="++ii">Siguiente</v-btn>
                                    </v-col>
                                </v-row>
                            </v-stepper-content>

                            <!-- Forma de Devolución -->
                            <v-stepper-step :complete="ii > 3" step="3"> Forma de Devolución</v-stepper-step>
                            <v-stepper-content step="3">
                                <StepperFormaDevolucionComponent :load="ii == 3 ? true : false"
                                    :listTipoDevolucion="_.get(listGeneral,'listTipoDevolucion',[])"
                                    :listInstitucionFinanciera="_.get(listGeneral,'listInstitucionFinanciera',[])"
                                    :listTipoCuenta="_.get(listGeneral,'listTipoCuenta',[])" :parametros="parametros"
                                    :nombreCliente="_.get(obSearch,'nombreCliente','')" 
                                    :textoTerminoCondicionExclusion="textoTerminoCondicionExclusion"/>

                                <v-row dense>
                                    <v-col class="text-right">
                                        <v-btn outlined rounded color="danger" @click="--ii" class="mr-1" :disabled="disabled">Anterior</v-btn>
                                        <v-btn rounded dark color="primary" @click="onBotonPago" :disabled="disabled">Guardar</v-btn>
                                    </v-col>
                                </v-row>
                            </v-stepper-content>

                        </v-stepper>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: 'ExclusionView',
        components:{
            StepperExclusionAccesorioComponent: () => import('@/components/ajustePoliza/exclusion/StepperExclusionAccesorioComponent.vue'),
            StepperFormaDevolucionComponent: () => import('@/components/ajustePoliza/exclusion/StepperFormaDevolucionComponent.vue'),
        },
        data: () => ({
            ii: 1,
            disabled: false,
            idSeguro: null,
            idCliente: null,
            listGeneral: [],
            obSearch: {},
            obSend: {
                listAccesoriosExcluir:[],
                obTipoDevolucion:{}
            },
            parametros: {},
            textoTerminoCondicionExclusion:''
        }),
        created() {
            axios.post(`${BASE_URI}administrador/exclusion/cargaGeneral`,{})
                 .then((r)=>{
                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                    if(_.size(_.get(r,['data','data'],[])) == 0 ) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                        this.idCliente = _.get(this.$root.obUsuario,'idCliente',null);
                        this.listGeneral = r.data.data.listas;
                        this.parametros = r.data.data.parametro;
                        this.onListarCertificados('L');
                 })
                 .catch((e)=>{
                     mensajesAlerta(e,'E');
                 });
        },
        watch:{
            ii(val){
                switch (val) {
                    case 3:
                        var chilAcc = this.$children[0].$children[0].$children[3].$children[2];
                        this.obSend.listAccesoriosExcluir = chilAcc.listAccesoriosExcluir;
                        this.obSend.obTipoDevolucion      = _.pick(chilAcc.obForm,['idMotivo','detalle']);
                        break;
                }
            }
        },
        methods: {
            apiSend(ruta, objeto) {
                return axios.post(`${BASE_URI}${ruta}`, objeto);
            },
            onListarCertificados(event) {
                if (!_.isUndefined(event)) {
                    var objeto = {
                        opcion: 'LISTAR_CERTIFICADO_PARA_EXCLUIR',
                        idCliente: _.get(this, 'idCliente', null)
                    };

                    var error = 'E';
                    this.$set(this.listGeneral, 'listDetalle', []);

                    return this.apiSend('administrador/exclusion/listar', objeto)
                        .then((r) => {
                            if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw r.data.mensaje; } 
                              this.$set(this.listGeneral, 'listDetalle', _.map(r.data.data,(v) => { v.index = _.uniqueId();  return v; }));
                        })
                        .catch((e) => {
                            mensajesAlerta(e, error);
                        })
                }
            },
            exclusion(objeto) {
                var o = { "opcion":"LISTAR_EXCLUSION", "idProducto": _.get(objeto,'idProducto',null) };

                axios.post(`${BASE_URI}administrador/producto-parametro/listar`,o)
                     .then((r)=>{
                        if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                        if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw r.data.mensaje; } 
                            this.textoTerminoCondicionExclusion = _.get(r.data.data,['0','textoTerminoCondicionExclusion'],'');
                            this.$set(this,'obSearch',_.cloneDeep(objeto));
                            ++this.ii;
                     })
                     .catch((e)=>{
                         mensajesAlerta(e,error);
                     });
            },
            insertarExclusion(objetoBotonPago) {
                var keys = {
                    search: ['idCertificado','idPoliza','idSeguro'],
                    tipo: ['idTipoDevolucion','idMotivo','detalle','nroCuenta','idTipoCuenta','idInstitucionFinaciera']
                };

                var objDatosPrincipales = _.merge({},
                                                {
                                                    opcion: 'I',                
                                                    idInclusion   : _.get(this.obSend.listAccesoriosExcluir, ['0','id_inclusion'], null)
                                                },
                                                 _.pick(this.obSearch,keys.search),
                                                 _.pick(this.obSend.obTipoDevolucion,keys.tipo),
                                                );

                var objeto = {
                                objDatosPrincipales: objDatosPrincipales,
                                listAccesoriosExcluir : _.map(this.obSend.listAccesoriosExcluir, _.partialRight(_.pick, ['id_inclusion_accesorio','id_inclusion']))
                            };
                
                this.disabled = true;
                this.apiSend('administrador/exclusion/insertOrUpdate', objeto)
                    .then((r) => {
                        if (_.size(_.get(r, ['data', 'data'], 0)) == 0) throw _.get(r, ['data','mensaje'], 'Ocurrio un error al realizar la petición.');
                            mensajeAlertaTiempo(r.data.mensaje +' Recibira al email con los detalles de su exclusión.', 'S');
                            setTimeout(() => {
                                window.location.reload();
                            }, 5000);
                    })
                    .catch((e) => {
                        this.disabled = false;
                        mensajesAlerta(e, 'E');
                    });
            },
            onBotonPago() {
                try {
                    var chilDevo = this.$children[0].$children[0].$children[5].$children[2];
                    var chilAcc = this.$children[0].$children[0].$children[3].$children[2];
                    
                    if(_.size(_.get(this.obSend,'listAccesoriosExcluir',[])) == 0) throw 'Debe seleccionar al menos un accesorio.';
                    if(chilAcc.validacion()){
                        if(chilDevo.validacion()){
                            this.obSend.obTipoDevolucion = _.merge({},
                                                                    this.obSend.obTipoDevolucion,
                                                                    chilDevo.obForm
                                                                  );
                            //Cuando el botón de pago responda que todo salio OK
                            var objeto = {};
                            this.insertarExclusion(objeto);
                        }
                    }
                } catch (e) {
                    mensajesAlerta(e, 'E');
                }
            }
        }
    }
</script>
<style>
    .removeBorder {
        box-shadow: none !important;
    } 
    .theme--dark.v-stepper{
        background: none !important;
    }

</style>